import type { RouteRecordRaw } from "vue-router";

export const coursesRoutes: RouteRecordRaw[] = [
  {
    path: "/fortbildungen",
    name: "courses",
    component: () => import("./CourseListPage.vue"),
    meta: {
      title: "courseCatalog.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id",
    name: "courses-id",
    component: () => import("./[id]/CourseDetailPage.vue"),
    meta: {
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/access_info",
    name: "courses-id-access-info",
    component: () => import("./[id]/access_info.vue"),
    meta: {
      requiresAuth: true,
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/documents",
    name: "courses-id-documents",
    component: () => import("./[id]/documents.vue"),
    meta: {
      requiresAuth: true,
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/feedback",
    name: "courses-id-feedback",
    component: () => import("./[id]/feedback.vue"),
    meta: {
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/feedback/new",
    name: "courses-id-feedback-new",
    component: () => import("./[id]/feedback/new.vue"),
    meta: {
      requiresAuth: true,
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/lessons/:lessonId",
    name: "courses-id-lessons-lessonId",
    component: () => import("./[id]/lessons/[lessonId].vue"),
    meta: {
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/status",
    name: "courses-id-status",
    component: () => import("./[id]/status.vue"),
    meta: {
      requiresAuth: true,
      title: "courseDetail.headers.title",
    },
  },
  {
    path: "/fortbildungen/:id/teacher",
    name: "courses-id-teacher",
    component: () => import("./[id]/teacher.vue"),
    meta: {
      title: "courseDetail.headers.title",
    },
  },
];
